

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BJjWI3gH.js","_app/immutable/chunks/stores.CuZyOi6d.js","_app/immutable/chunks/client.--7n92yq.js"];
export const stylesheets = [];
export const fonts = [];
